// extracted by mini-css-extract-plugin
export var colorSquare = "_qj-0";
export var danger = "_qj-5";
export var lightPink = "_qj-8";
export var neutralBlue = "_qj-7";
export var neutralYellow = "_qj-6";
export var normal = "_qj-1";
export var primary = "_qj-2";
export var primaryLight = "_qj-3";
export var solidBlack = "_qj-g";
export var solidGreen = "_qj-b";
export var solidLightBlue = "_qj-d";
export var solidNavy = "_qj-c";
export var solidOrange = "_qj-f";
export var solidPink = "_qj-e";
export var solidRed = "_qj-9";
export var solidYellow = "_qj-a";
export var success = "_qj-4";